import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// bayclubs module
import { BcEmployeeOAuthCallbackComponent } from '@bayclubs/employee-auth';
import { createHorizonErrorRoutes, createHorizonLoginRoutes } from '@bayclubs/horizon';

export const authRoutes: Routes = [
    // this have to be relative redirect. Otherwise query params are not retained and the auto login feature not working
    ...createHorizonLoginRoutes(),
    { path: 'code', component: BcEmployeeOAuthCallbackComponent },
    ...createHorizonErrorRoutes(),
];

@NgModule({
    imports: [RouterModule.forChild(authRoutes)],
})
export class AuthModule {}
